module.exports = __webpack_public_path__ + "f914deb394418aa46bbb5c95ba6803d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/images/ch_grid_8-mobile.png
// module id = 134
// module chunks = 1